import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'experience-scheduling-tab-1-part',
	standalone: true,
	templateUrl: './experience-scheduling-tab-1.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./experience-scheduling-tab-1.part.scss`],
})
export class ExperienceSchedulingTab1Part {
}
